import React from 'react';
import styled from 'styled-components';

const StatusWrapper = styled.div`
    border-radius: 5px;
    padding: 5px;
    width: 100px;
    border-style: solid;
    border-width: thin;
    font-size: 12px;
    text-align: center;
    ${props => props.status === 'Pago' && `
        border-color: ${props.theme.colors.success};
        color: ${props.theme.colors.success};
    `}
    ${props => props.status === 'Chargeback' && `
        border-color: ${props.theme.colors.error};
	    color: ${props.theme.colors.error};
    `}
    ${props => props.status === 'Estorno Parcial' && `
        border-color: ${props.theme.colors.warning};
	    color: ${props.theme.colors.warning};
    `}
    ${props => props.status === 'Estornado' && `
        border-color: ${props.theme.colors.secondWarning};
	    color: ${props.theme.colors.secondWarning};
    `}

`
export const OrderStatus = (props) => props.status ? (
    <StatusWrapper {...props}>
        {props.status}
    </StatusWrapper>
) : null